import {
  useHistoryDateFiltersDictionary,
  useHistoryFiltersDictionary,
  useOperationStatusIcons,
  useOperationTypesIcons,
} from '@/shared/api';
import { useMemo } from 'react';

export const useHistoryDictionaries = () => {
  const { operationTypeIconsData, isOperationTypesIconsLoading } =
    useOperationTypesIcons();
  const { operationsStatusIconsData, isOperationStatusIconsLoading } =
    useOperationStatusIcons();
  const {
    data: operationTypesData,
    isLoading: isOperationTypesLoading,
    error: operationTypesError,
  } = useHistoryFiltersDictionary();

  const {
    data: dateFiltersData,
    isLoading: isDateFiltersLoading,
    error: dateFiltersError,
  } = useHistoryDateFiltersDictionary();

  const isLoading =
    isOperationTypesIconsLoading ||
    isOperationStatusIconsLoading ||
    isOperationTypesLoading ||
    isDateFiltersLoading;

  const operationTypes = useMemo(
    () => operationTypesData?.value ?? [],
    [operationTypesData]
  );

  const dateFilters = useMemo(
    () => dateFiltersData?.value ?? [],
    [dateFiltersData]
  );

  const operationTypeIcons = useMemo(
    () => operationTypeIconsData?.value ?? [],
    [operationTypeIconsData]
  );

  const operationStatusIcons = useMemo(
    () => operationsStatusIconsData?.value ?? [],
    [operationsStatusIconsData]
  );

  const error = operationTypesError || dateFiltersError;

  return {
    isLoading,
    error,
    operationTypes,
    dateFilters,
    operationTypeIcons,
    operationStatusIcons,
  };
};
